import { render, staticRenderFns } from "./clientListDialog.vue?vue&type=template&id=0db8f7ff&scoped=true"
import script from "./clientListDialog.vue?vue&type=script&lang=js"
export * from "./clientListDialog.vue?vue&type=script&lang=js"
import style0 from "./clientListDialog.vue?vue&type=style&index=0&id=0db8f7ff&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8f7ff",
  null
  
)

export default component.exports